import { render } from "./HeroPagination.vue?vue&type=template&id=b519cb10&scoped=true"
import script from "./HeroPagination.vue?vue&type=script&lang=js"
export * from "./HeroPagination.vue?vue&type=script&lang=js"

import "./HeroPagination.vue?vue&type=style&index=0&id=b519cb10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b519cb10"]])

export default __exports__